import React, { Component } from "react";

import {
  Wrapper,
  Title,
  Copy,
  ExternalImage,
  Row,
  Card,
  Video
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import { openUrl } from "app/NativeActions";
import GenerateText from "../GenerateText";

class VideoCard extends Component {
  renderVideo() {
    const { onboarding_landing_page } = this.props;

    if (
      (!this.props.isMobile || this.props.device == "mobile") &&
      onboarding_landing_page.video
    ) {
      return (
        <Wrapper
          style={{
            width: "100%",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Video
            video={onboarding_landing_page.video.fields.file.url}
            width={"100%"}
            height={this.props.isMobile ? 250 : 400}
            autoPlay={true}
            controls={false}
            muted={true}
            loop={true}
            cover={true}
          />
        </Wrapper>
      );
    }
  }

  render() {
    const { colors, onboarding_landing_page } = this.props;

    return (
      <Wrapper style={{ alignSelf: "stretch", flex: 1 }}>
        <Card style={{ flex: 1, overflow: "hidden" }}>
          <Wrapper style={{ padding: 25 }}>
            <Wrapper
              style={{
                flexDirection: this.props.isMobile ? "column" : "row",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Wrapper
                style={{
                  paddingRight: 25,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <ExternalImage
                  style={{
                    resizeMode: "contain",
                    width: !this.props.isMobile ? 150 : 150,
                    height: !this.props.isMobile ? 150 : 150
                  }}
                  contain={true}
                  image={
                    onboarding_landing_page.image
                      ? onboarding_landing_page.image.fields.file.url
                      : ""
                  }
                />
              </Wrapper>
              <Wrapper style={{ flex: 1 }}>
                <Copy
                  style={{
                    color: colors.light_text_color,
                    textAlign: this.props.isMobile ? "center" : "left"
                  }}
                >
                  {onboarding_landing_page.subtitle}
                </Copy>
                <GenerateText
                  {...this.props}
                  center={this.props.isMobile ? true : false}
                  onboarding_title={onboarding_landing_page.title}
                  onboarding_text={onboarding_landing_page.description}
                  primaryButtonText={onboarding_landing_page.primaryButtonText}
                  secondaryButtonText={
                    onboarding_landing_page.secondaryButtonText
                  }
                  secondaryButtonLink={
                    onboarding_landing_page.secondaryButtonLink
                  }
                  onboarding_info={this.props.onboarding_info}
                />
              </Wrapper>
            </Wrapper>
          </Wrapper>
          {this.renderVideo()}
        </Card>
      </Wrapper>
    );
  }
}
export default VideoCard;
